import { FixedBoxTitle } from "pro-features/components/BoxTitle/src/FixedBoxTitle";
import { translate } from "app/filters/i18nFilter";
import styled from "styled-components";
import { colorsPalettes } from "@similarweb/styles";
import { FlexColumn } from "pro-features/styled components/StyledFlex/src/StyledFlex";
import { DurationFilter } from "../../common/DurationFilter";
import { ToggleFilter } from "pro-features/components/filtersPanel/src/ToggleFilter";
import { useStateWithDeeplink } from "app/custom-hooks/useStateWithDeeplink";
import { CategoryServiceUtils } from "app/services/CategoryServiceUtils";
import { isUseDomainsOnly } from "../../utils/getUseDomainsOnly";
import { allTrackers } from "app/services/track/track";

const { carbon } = colorsPalettes;

const Container = styled.div`
    display: flex;
    justify-content: space-between;
    padding: 12px 48px 12px 24px;
    border-bottom: 1px solid ${carbon[100]};
    align-items: center;
`;

export const Title = () => {
    const [useDomainsOnly, setUseDomainsOnly] = useStateWithDeeplink<boolean>({
        param: "useDomainsOnly",
        urlToStateAdapter: isUseDomainsOnly,
    });

    const selectedCategoryHasSegments = CategoryServiceUtils.selectedCategoryHasSegments();
    const onUseDomainsOnlyChange = () => {
        const updatedUseDomainsOnly = !useDomainsOnly;
        const trackingFilters = { useDomainsOnly: updatedUseDomainsOnly };
        allTrackers.dispatchTrackEvent("Button", "click", "useDomainsOnly", trackingFilters);
        setUseDomainsOnly(updatedUseDomainsOnly);
    };
    return (
        <Container>
            <FlexColumn gap={"8px"}>
                <FixedBoxTitle
                    title={translate("market.research.players.bubble.title")}
                    tooltip={translate("market.research.players.bubble.title.tooltip")}
                />
                <DurationFilter />
            </FlexColumn>
            {selectedCategoryHasSegments && (
                <ToggleFilter
                    isActive={useDomainsOnly}
                    onClick={onUseDomainsOnlyChange}
                    label={translate("market.research.players.bubble.title.use.domains.label")}
                    tooltip={translate("market.research.players.bubble.title.use.domains.label.tooltip")}
                />
            )}
        </Container>
    );
};
